import React from 'react';
import { Paper, Typography, Divider, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const FormContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(6),
  margin: theme.spacing(4),
  borderRadius: '16px',
  boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
  backgroundColor: '#ffffff',
  maxWidth: '600px',
}));

const FormContainerWrapper = ({ title, children }) => {
  return (
    <Box className="min-h-screen bg-gray-100 flex justify-center items-center p-6">
      <FormContainer elevation={4}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: 'bold', color: '#333' }}
        >
          {title}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        {children}
      </FormContainer>
    </Box>
  );
};

export default FormContainerWrapper;